import { Link } from "react-router-dom";
import React, { Component } from "react";
import { PATHS } from "../../common/constants";
import Actions from "../Actions";
import Button from "../Button";
import Empty from "../Empty";
import Icon from "../Icon";
import Overlay from "../Overlay";
import PropertyForm from "../PropertyForm";
import Table, { Hidden } from "../Table";
import Search from "../Search";
import {
  setPropertyFormData,
  clearPropertyFormData,
} from "../../store/actions/propertyForm";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectSearch } from "../../store/selectors/search";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { exitEasyWalkThroughForm } from "../../store/actions/easyWalkThroughForm";
import { exitPropertyWalkThroughForm } from "../../store/actions/propertyWalkThroughForm";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
// import variables from '../../styles/includes/variables.scss';
import { checkSparkDataAvailable } from "../../helpers/validationHelper";

import { variables } from "../../Tenants";
import { setSelectedModulePermission } from "../../store/actions/tabSelections";

class PropertiesTable extends Component {
  state = {
    showOverlay: false,
  };

  onSetPropertFormData(data) {
    const { setPropertyFormData, setSelectedModulePermission } = this.props;
    setPropertyFormData(data);
    let modulePermissions = [];
    if (data.modulePermissions !== null) {
      modulePermissions = data.modulePermissions.map((item) => {
        return { Id: item.id };
      });
    }
    setSelectedModulePermission(modulePermissions);
  }
  render() {
    const {
      properties,
      loader,
      onSaveProperty,
      onSearch,
      setPropertyFormData,
      clearPropertyFormData,
      onDeleteProperty,
      search,
      onExitEasyWalkThroughForm,
      onExitPropertyWalkThroughForm,
      tabList,
      clearSelectedModulePermission,
    } = this.props;
    const { showOverlay } = this.state;
    return (
      <>
        {loader ? <Loader center={true} /> : null}
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Properties..."
            onChange={onSearch}
          />
          {this.props.user.roles[0].role.name === "Admin" ||
          this.props.user.roles[0].role.name === "Super Admin" ? (
            <Button
              color="teal"
              label="Add Property"
              onClick={() => {
                this.setState({ showOverlay: true });
              }}
              icon={<Icon glyph="building" weight="light" size="small" />}
              size="small"
            />
          ) : null}
        </Actions>
        {properties.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: "Property",
                  accessor: "name",
                  sortable: true,
                  cell: (data) => (
                    <Link
                      onClick={() => {
                        onExitPropertyWalkThroughForm();
                        onExitEasyWalkThroughForm();
                      }}
                      to={PATHS.PROPERTIES_VIEW.replace(":id", data.id)}
                    >
                      {data.name}
                    </Link>
                  ),
                },
                {
                  label: "Address",
                  accessor: "addressLine1",
                },
                {
                  center: true,
                  xsHide: true,
                  label: variables.Suite + "s",
                  accessor: "suits",
                },
                {
                  center: true,
                  xsHide: true,
                  label: variables.serviceRequest + "s",
                  accessor: "serviceRequests",
                },
                {
                  cell: (data) =>
                    checkSparkDataAvailable(
                      data,
                      this.props.user.roles[0].role.name
                    ) ||
                    this.props.user.roles[0].role.name === "Home Owner" ||
                    this.props.user.roles[0].role.name === "Occupant" ? null : (
                      <Hidden>
                        <Button
                          color="semantic"
                          label={<Icon glyph="pencil" weight="light" />}
                          onClick={() => {
                            this.onSetPropertFormData(data);
                            this.setState({ showOverlay: true });
                          }}
                        />
                        {this.props.user.roles[0].role.name === "Admin" ||
                        this.props.user.roles[0].role.name === "Super Admin" ? (
                          <Button
                            color="semantic"
                            onClick={() =>
                              window.confirm(
                                `Are you sure you want to delete ${data.name}?`
                              ) && onDeleteProperty(data)
                            }
                            label={<Icon glyph="trash" weight="light" />}
                          />
                        ) : null}
                      </Hidden>
                    ),
                },
              ]}
              data={properties}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="No properties yet"
            strapline="All properties you add will be listed here so it’s easier for you to manage."
            searchIsActive={
              search && search.properties ? search.properties : ""
            }
            cta={
              this.props.user.roles[0].role.name === "Admin" ? (
                <Button
                  color="teal"
                  label="Add Property"
                  onClick={() => {
                    setPropertyFormData({
                      name: "",
                      addressLine1: "",
                      city: "",
                      province: "",
                      postalCode: "",
                    });
                    this.setState({ showOverlay: true });
                  }}
                  icon={<Icon glyph="building" weight="light" size="small" />}
                  size="small"
                />
              ) : null
            }
            image={
              <img alt="No properties yet" src="/assets/empty/properties.svg" />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <PropertyForm
              tabList={tabList}
              onClose={() => {
                this.setState({ showOverlay: false }, () => {
                  clearPropertyFormData();
                  clearSelectedModulePermission();
                });
              }}
              onSaveProperty={onSaveProperty}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  loader: selectFormLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPropertyFormData,
      setSelectedModulePermission,
      clearPropertyFormData,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesTable);
